const GEN_FILES_ENDPOINTS = {
  CURRENT: '/gen-files/current',
  UPLOAD: '/gen-files',
};

export default GEN_FILES_ENDPOINTS;
